/* ============================================================
   Cupón de la página de feria (sections/daza-feria.liquid)
   - Tras enviar el correo Shopify recarga la página: el cupón queda
     abajo de la foto y del título, así que se trae a la vista y recibe
     el foco (el título si salió bien, el campo si hubo error).
   - «Copiar» aparece con JS: portapapeles moderno y, si el navegador lo
     niega, selección + método clásico. Sin JS, el código se selecciona
     entero con un toque (user-select: all).
   ============================================================ */
if (!customElements.get('daza-cupon')) {
  customElements.define(
    'daza-cupon',
    class DazaCupon extends HTMLElement {
      connectedCallback() {
        // Tras la recarga, el foco va al título del cupón (éxito) o al
        // campo de correo (Shopify rechazó el correo; el campo lleva
        // aria-describedby hacia el error, así que el lector lo lee).
        // Se espera a «load» y se trae el cupón a la vista de golpe: es una
        // recarga, no hace falta animar el viaje.
        const objetivo =
          this.querySelector('[data-cupon-exito] [data-cupon-foco]') ||
          this.querySelector('.s-feria__input[data-cupon-foco]');
        if (objetivo) {
          const mostrar = () =>
            requestAnimationFrame(() =>
              requestAnimationFrame(() => {
                this.scrollIntoView({ block: 'start', behavior: 'instant' });
                objetivo.focus({ preventScroll: true });
              })
            );
          if (document.readyState === 'complete') mostrar();
          else window.addEventListener('load', mostrar, { once: true });
        }

        const boton = this.querySelector('[data-cupon-copiar]');
        const codigo = this.querySelector('[data-cupon-codigo]');
        if (!boton || !codigo) return;

        const texto = boton.querySelector('[data-cupon-copiar-txt]');
        const aviso = this.querySelector('[data-cupon-aviso]');
        boton.hidden = false;
        boton.addEventListener('click', async () => {
          const valor = codigo.textContent.trim();
          let copiado = false;
          try {
            await navigator.clipboard.writeText(valor);
            copiado = true;
          } catch (e) {
            // Sin permiso para el portapapeles (navegadores dentro de apps,
            // algunos webviews): se selecciona el código y se usa el
            // método clásico. La selección sirve igual para copiarlo a mano.
            const rango = document.createRange();
            rango.selectNodeContents(codigo);
            const seleccion = window.getSelection();
            seleccion.removeAllRanges();
            seleccion.addRange(rango);
            try {
              copiado = document.execCommand('copy');
            } catch (e2) {
              copiado = false;
            }
          }
          if (copiado) {
            texto.textContent = 'Copiado';
            if (aviso) aviso.textContent = 'Código copiado. Pégalo al pagar.';
            clearTimeout(this.reponer);
            this.reponer = setTimeout(() => {
              texto.textContent = 'Copiar';
            }, 2500);
          } else if (aviso) {
            aviso.textContent = 'Código seleccionado: cópialo desde el menú de tu teléfono.';
          }
        });
      }
    }
  );
}
